import React from "react";

export default function InternalServerError() {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center vh-100 text-center"
      style={{ fontFamily: "Arial, sans-serif" }}
    >
      {/* Google Logo */}
      <h1 style={{ fontSize: "2.5rem", fontWeight: "normal" }}>
        <span style={{ color: "#4285F4" }}>G</span>
        <span style={{ color: "#EA4335" }}>o</span>
        <span style={{ color: "#FBBC05" }}>o</span>
        <span style={{ color: "#4285F4" }}>g</span>
        <span style={{ color: "#34A853" }}>l</span>
        <span style={{ color: "#EA4335" }}>e</span>
      </h1>

      {/* Error Code */}
      <h3
        className="mt-3"
        style={{ fontWeight: "bold", fontSize: "1.5rem", color: "#333" }}
      >
        500{" "}
        <span style={{ fontWeight: "normal", color: "#555" }}>
          Internal Error.
        </span>
      </h3>

      {/* Error Message */}
      <p
        className="mt-2"
        style={{ fontSize: "1rem", color: "#555", maxWidth: "500px" }}
      >
        The server encountered an error and could not complete your request.
        <br />
        If the problem persists, please report your problem and mention this
        error message and the query that caused it.
      </p>

      {/* Subtext */}
      <p style={{ fontSize: "0.9rem", color: "#777" }}>That’s all we know.</p>

      {/* Robot Image */}
      {/* <img
        src="https://www.gstatic.com/youtube/img/branding/errorpage/robot.png"
        alt="Google Error Robot"
        style={{ maxWidth: "220px", marginTop: "20px" }}
      /> */}
    </div>
  );
}
